<template>
  <div class="page-index">
    <el-container>
      <el-header>
        <span class="page-title">{{ pageTitle }}</span>
      </el-header>
      <el-container>
        <el-aside width="13vw">
          <div class="menu-box user-box" @click="userInfo">
            <div class="menu-content">
              <div class="menu-img-box">
                <img :src="userImg" class="menu-img" />
              </div>
              <div class="menu-text">{{ username }}</div>
            </div>
          </div>
          <div class="menu-box" v-for="(item, index) in menuList" :key="index" @click="handleMenu(item, index)">
            <div class="menu-content" :class="activeIndex == index ? 'menu-box-active' : ''">
              <div class="menu-img-box">
                <img :src="
                  activeIndex == index ? item.menuActiveImg : item.menuImg
                " class="menu-img" />
              </div>
              <div class="menu-text">{{ item.menuName }}</div>
            </div>

            <div v-if="item.isExtend">
              <div class="menu-box" :class="
                activeIndex == index + String(idex) ? 'menu-box-active' : ''
              " v-for="(itm, idex) in item.children" :key="idex" @click.stop="handleSubMenu(index, itm, idex)">
                <div class="menu-content">
                  <div class="menu-img-box sub-menu-img-box">
                    <img :src="
                      activeIndex == index + String(idex)
                        ? item.menuActiveImg
                        : item.menuImg
                    " class="menu-img" />
                  </div>
                  <div class="menu-text">{{ itm.menuName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="menu-box exit-box" @click="exit">
            <div class="menu-content">
              <div class="menu-img-box">
                <img :src="exitImg" class="menu-img" />
              </div>
              <div class="menu-text">退出</div>
            </div>
          </div>
        </el-aside>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { loginOut } from "../api/user";
export default {
  name: "Index",
  data() {
    return {
      pageTitle: "",
      userImg: require("../assets/images/main/user.svg"),
      menuList: [
        {
          menuImg: require("../assets/images/main/realTime.svg"),
          menuActiveImg: require("../assets/images/main/realTimeActive.svg"),
          menuName: "实时数据",
          path: "/real-time",
        },
        {
          menuImg: require("../assets/images/main/history.svg"),
          menuActiveImg: require("../assets/images/main/historyActive.svg"),
          menuName: "历史数据",
          // path: "/history",
          type: "submenu",
          isExtend: false,
          children: [
            {
              menuImg: require("../assets/images/main/history.svg"),
              menuActiveImg: require("../assets/images/main/historyActive.svg"),
              menuName: "报告数据",
              path: "/history",
            },
            {
              menuImg: require("../assets/images/main/history.svg"),
              menuActiveImg: require("../assets/images/main/historyActive.svg"),
              menuName: "跌倒数据",
              path: "/history-down",
            },
          ],
        },
      ],
      activeIndex: -1,
      exitImg: require("../assets/images/main/exit.svg"),
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    username() {
      return this.$store.getters.user.username;
    },
  },
  mounted() {
    if (this.user === null) {
      this.$router.push({ path: "/login" });
      return;
    } else {
      if (this.user.roleId == 1) {
        this.menuList = [
          {
            menuImg: require("../assets/images/main/realTime.svg"),
            menuActiveImg: require("../assets/images/main/realTimeActive.svg"),
            menuName: "实时数据",
            path: "/real-time",
          },
          {
            menuImg: require("../assets/images/main/history.svg"),
            menuActiveImg: require("../assets/images/main/historyActive.svg"),
            menuName: "历史数据",
            // path: "/history",
            type: "submenu",
            isExtend: false,
            children: [
              {
                menuImg: require("../assets/images/main/history.svg"),
                menuActiveImg: require("../assets/images/main/historyActive.svg"),
                menuName: "报告数据",
                path: "/history",
              },
              {
                menuImg: require("../assets/images/main/history.svg"),
                menuActiveImg: require("../assets/images/main/historyActive.svg"),
                menuName: "跌倒数据",
                path: "/history-down",
              },
            ],
          },
          {
            menuImg: require("../assets/images/main/tower.svg"),
            menuActiveImg: require("../assets/images/main/towerActive.svg"),
            menuName: "楼层编辑",
            path: "/system/tower",
          },
          {
            menuImg: require("../assets/images/main/authEdit.svg"),
            menuActiveImg: require("../assets/images/main/authEditActive.svg"),
            menuName: "权限设置",
            path: "/system/user",
          },
          {
            menuImg: require("../assets/images/main/deviceEdit.svg"),
            menuActiveImg: require("../assets/images/main/deviceEditActive.svg"),
            menuName: "设备配置",
            // path: "/system/device",
            type: "submenu",
            isExtend: false,
            children: [
              {
                menuImg: require("../assets/images/main/deviceEdit.svg"),
                menuActiveImg: require("../assets/images/main/deviceEditActive.svg"),
                menuName: "体征雷达",
                path: "/system/device",
              },
              {
                menuImg: require("../assets/images/main/deviceEdit.svg"),
                menuActiveImg: require("../assets/images/main/deviceEditActive.svg"),
                menuName: "跌倒雷达",
                path: "/system/device-down",
              },
            ],
          },
          {
            menuImg: require("../assets/images/main/deviceEdit.svg"),
            menuActiveImg: require("../assets/images/main/deviceEditActive.svg"),
            menuName: "设备列表",
            path: "/system/deviceList",
          },
          {
            menuImg: require("../assets/images/main/deviceEdit.svg"),
            menuActiveImg: require("../assets/images/main/deviceEditActive.svg"),
            menuName: "未匹配设备",
            path: "/system/noMatch",
          },
          {
            menuImg: require("../assets/images/main/history.svg"),
            menuActiveImg: require("../assets/images/main/historyActive.svg"),
            menuName: "推送日志",
            path: "/system/push-log",
          },
        ];
      }
    }
    this.getPath();
  },
  methods: {
    handleMenu(item, index) {
      if (item.type == "submenu") {
        item.isExtend = !item.isExtend;
      } else {
        this.pageTitle = item.menuName;
        this.activeIndex = index;

        if (item.path != this.$route.path) {
          this.$router.push(item.path);
        }
      }
    },

    handleSubMenu(index, itm, idex) {
      this.pageTitle = itm.menuName;
      this.activeIndex = index + String(idex);

      if (itm.path != this.$route.path) {
        this.$router.push(itm.path);
      }
    },

    getPath() {
      this.menuList.forEach((item, index) => {
        if (item.path == this.$route.path) {
          this.activeIndex = index;
          this.pageTitle = item.menuName;
        }
        if (item.children) {
          item.children.forEach((itm, idex) => {
            if (itm.path == this.$route.path) {
              this.activeIndex = index + String(idex);
              this.pageTitle = itm.menuName;
              item.isExtend = true;
            }
          });
        }
      });
    },

    userInfo() {
      this.$router.push("/set-pwd");
      this.pageTitle = "修改密码";
      this.activeIndex = -1;
    },

    exit() {
      loginOut().then((res) => { });
      this.$store.dispatch("setUser", null);
    },
  },

  destroyed() { },

  watch: {
    $route() {
      this.getPath();
    },

    user(val, old) {
      if (val == null) {
        this.$router.push({ path: "/login" });
      }
    },
  },
};
</script>

<style scoped lang='less'>
@blue: #1d63fd;
@bg: #fffefa;

.page-index {
  width: 100%;
  height: 100vh;
  background: #efefef;
  color: #26415f;

  .el-container {
    width: 100%;
    height: 100%;

    .el-header {
      height: 80px !important;
      line-height: 80px;
      // background: #fff;
      background: @bg;
      padding: 0;

      .page-title {
        font-size: 24px;
        margin-left: 13vw;
      }
    }

    .el-aside {
      // background: #fff;
      background: @bg;
      // border-radius: 0 0 0 12px;

      .user-box {
        // margin-top: 80px;
      }

      .menu-box {
        // width: 398px;
        width: 13vw;
        // height: 75px;
        // height: 7.5vh;
        // display: flex;
        // align-items: center;
        font-size: 14px;
        cursor: pointer;
        user-select: none;

        .menu-content {
          width: 13vw;
          height: 6.5vh;
          display: flex;
          align-items: center;
        }

        .menu-img-box {
          width: 14px;
          height: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 24px;

          img {
            width: 14px;
            height: 14px;
          }
        }

        .sub-menu-img-box {
          margin-left: 60px;
        }
      }

      .menu-box-active {
        background: @blue;
        color: #fff;
      }

      .exit-box {
        position: absolute;
        left: 0;
        bottom: 4vh;
      }
    }

    .el-main {
      padding: 0;
      // padding: 30px;
      // box-sizing: border-box;
    }
  }
}
</style>
<style>
.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue